export default "__VITE_PUBLIC_ASSET__7af1b72d__"